import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './base-api/api.service';
import { AppNotification } from '../models/notification';

/** The in-app notification tray. Every user only ever sees their own entries. */
@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly api = inject(ApiService);

  getNotifications(unreadOnly = false, take = 20): Observable<AppNotification[]> {
    const params = new URLSearchParams({ unreadOnly: String(unreadOnly), take: String(take) });
    return this.api
      .get<{ data: AppNotification[] }>(`notifications?${params.toString()}`)
      .pipe(map((response) => response.data ?? []));
  }

  getUnreadCount(): Observable<number> {
    return this.api
      .get<{ data: { unread: number } }>('notifications/unread-count')
      .pipe(map((response) => response.data?.unread ?? 0));
  }

  markRead(id: number): Observable<unknown> {
    return this.api.put(`notifications/${id}/read`, {});
  }

  markAllRead(): Observable<unknown> {
    return this.api.put('notifications/read-all', {});
  }
}
